(function () {
  const registryButtonSelector = '.giftreggie-pdp-registry-cta';
  const nativeButtonSelector = '.product-form__submit';

  function getRegistryReturnUrl() {
    try {
      const storedUrl = sessionStorage.getItem('NuaGiftRegistryReturnUrl');
      if (!storedUrl) return '';

      const parsedUrl = new URL(storedUrl, window.location.origin);
      const isRegistryPath = /^\/apps\/giftregistry\/registry\/\d+\/?$/.test(parsedUrl.pathname);

      return parsedUrl.origin === window.location.origin && isRegistryPath
        ? parsedUrl.pathname
        : '';
    } catch (error) {
      return '';
    }
  }

  function addRegistryReturnLink(registryButton) {
    const returnUrl = getRegistryReturnUrl();
    const ctaArea = registryButton.closest('.giftreggie-pdp-cta-area');

    if (!returnUrl || !ctaArea || ctaArea.querySelector('.giftreggie-pdp-return-link')) return;

    const returnLink = document.createElement('a');
    returnLink.className = 'giftreggie-pdp-return-link';
    returnLink.href = returnUrl;
    returnLink.textContent = 'Regresar a mi lista';
    ctaArea.appendChild(returnLink);
  }

  function syncGiftReggieButtons() {
    document.querySelectorAll('product-info').forEach(function (productInfo) {
      const nativeButton = productInfo.querySelector(nativeButtonSelector);
      const registryButton = productInfo.querySelector(registryButtonSelector);

      if (!nativeButton || !registryButton) return;

      const shouldDisable = nativeButton.disabled;

      if (registryButton.disabled !== shouldDisable) {
        registryButton.disabled = shouldDisable;
      }

      registryButton.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
      addRegistryReturnLink(registryButton);
    });

    document.querySelectorAll('[data-gift-registry-card-action]').forEach(function (cardAction) {
      const registryButton = cardAction.querySelector(registryButtonSelector);

      cardAction.classList.toggle('gift-registry-card-action--ready', Boolean(registryButton));

      if (!registryButton) return;

      if (cardAction.dataset.giftRegistryHasMultipleVariants === 'true') {
        const multiVariantTrigger = cardAction.querySelector('[data-gift-registry-multi-trigger]');

        if (multiVariantTrigger) multiVariantTrigger.hidden = false;
        return;
      }

      const shouldDisable = cardAction.dataset.giftRegistryAvailable !== 'true';

      if (registryButton.disabled !== shouldDisable) {
        registryButton.disabled = shouldDisable;
      }

      registryButton.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
    });
  }

  const observer = new MutationObserver(syncGiftReggieButtons);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled']
  });

  syncGiftReggieButtons();
})();
